module.exports = __webpack_public_path__ + "static/media/unibest-banner1.2a9d5f71.png";